<h2 mat-dialog-title>Edit Transaction</h2>

<form [formGroup]="form" (ngSubmit)="onSave()" autocomplete="off">
	<mat-dialog-content>
		<p class="dialog-hint">
			Corrects a transaction that has not been sent to KapCharge yet. Changes apply to this
			transaction only — the customer's record on the loan is not changed.
			<ng-container *ngIf="willRequeue">
				Saving also re-queues it for the next submission run.
			</ng-container>
		</p>

		<dl class="context">
			<dt>Loan Number</dt>
			<dd>{{ data.transaction.loanNumber || '—' }}</dd>
			<dt>Due Date</dt>
			<dd>{{ dueDate }}</dd>
		</dl>

		<formly-form [form]="form" [fields]="fields" [model]="model"></formly-form>

		<div *ngIf="errorMessage" class="match-result error">
			<mat-icon>error_outline</mat-icon>
			<span>{{ errorMessage }}</span>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions align="end">
		<button mat-stroked-button type="button" [disabled]="isSaving" (click)="onCancel()">Cancel</button>
		<button mat-raised-button color="primary" type="submit" [disabled]="!canSave">
			<mat-spinner *ngIf="isSaving" diameter="16" class="btn-spinner"></mat-spinner>
			<span>Save</span>
		</button>
	</mat-dialog-actions>
</form>